export const environment = {
  production: false,
  apiUrl: 'https://fpisvapidev.clavisco.com/api/',
  name: 'Frutera la Paz ISV',
  env: 'Development',
  recatchaSiteKey: '6Lcx4YAsAAAAAEsxsenxN6Nl0DzSO4sYdc_qxV_1',
  logrocket: ''
}